import { Box, Button } from '@mui/material';
import React from 'react';

interface ActionButtonProps {
    onClick: () => void;
    label: string;
    color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
}

const ActionButton: React.FC<ActionButtonProps> = ({ onClick, label, color = 'primary' }) => (
    <Box>
        <Button
            size="small"
            color={color}
            onClick={onClick}
            sx={{
                textTransform: 'none',
                p: 0,
                mb: '0',
                mt: '0px',
                minHeight: 20,
                height: 20,
                lineHeight: '20px',
            }}
        >
            {label}
        </Button>
    </Box>
);

export default ActionButton;
